/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fuehrungzeugnisgueltigab2Inputs */

const de__field_fuehrungzeugnisgueltigab2 = /** @type {(inputs: _Field_Fuehrungzeugnisgueltigab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Führungszeugnis`)
};

/**

* @param {_Field_Fuehrungzeugnisgueltigab2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fuehrungzeugnisgueltigab2 = /** @type {((inputs?: _Field_Fuehrungzeugnisgueltigab2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fuehrungzeugnisgueltigab2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_fuehrungzeugnisgueltigab2(inputs)
});
export { _field_fuehrungzeugnisgueltigab2 as "_field_fuehrungzeugnisGueltigAb" }